import { Component, Inject, LOCALE_ID } from '@angular/core'
import { MatCardModule } from '@angular/material/card'
import { MatTabsModule } from '@angular/material/tabs'
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog'
import { CommonModule } from '@angular/common'
import { Programa } from '../../models/programa.model'
import { DocenteComponent } from './docente/docente.component'
import { DisciplinaComponent } from './disciplina/disciplina.component'
import { LinhaPesquisaComponent } from "./linha-pesquisa/linha-pesquisa.component";
import { MatButtonModule } from '@angular/material/button'

@Component({
  selector: 'app-programa-visualizar',
  templateUrl: 'programa-visualizar.component.html',
  styleUrls: ['./programa-visualizar.component.scss'],
  imports: [
    CommonModule,
    MatDialogModule,
    MatCardModule,
    MatTabsModule,
    MatButtonModule,
    LinhaPesquisaComponent,
    DisciplinaComponent,
    DocenteComponent,
  ]
})
export class ProgramaVisualizarComponent {

  txtE: string = ' e '

  constructor(
    public dialogRef: MatDialogRef<ProgramaVisualizarComponent>,
    @Inject(MAT_DIALOG_DATA) public programa: Programa,
    @Inject(LOCALE_ID) public locale: string,
  ) {
    if (this.locale != 'pt') {
      this.txtE = ' and '
    }
  }

  abrirUrl(url: string): void {
    if (url) {
      const destino = url.startsWith('http') ? url : `http://${url}`
      window.open(destino)
    }
  }

}